var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('button', {
    staticClass: "vactionbutton",
    class: {
      pressed: _vm.isPressed
    },
    attrs: {
      "id": _vm.id,
      "data-test": "vactionbutton",
      "type": "button"
    },
    on: {
      "&click": function ($event) {
        return _vm.emitClick($event);
      },
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.emitEsc($event);
      }
    }
  }, [_vm._t("icon", function () {
    return [_vm.showIcon ? _c('object', {
      staticStyle: {
        "pointer-events": "none"
      },
      style: 'fill:' + _vm.isPressed ? '#FFF' : '#000;',
      attrs: {
        "type": "image/svg+xml",
        "data": _vm.iconSrc
      }
    }, [_vm._v("\n        " + _vm._s(_vm.iconAlt) + "\n      ")]) : _vm._e()];
  }), _vm._v(" "), _vm._t("label", function () {
    return [_vm.showLabel ? [_vm._v("\n        " + _vm._s(_vm.label) + "\n      ")] : _vm._e()];
  }), _vm._v(" "), _vm._t("badge", function () {
    return [_vm.showBadge ? _c('span', {
      staticClass: "count",
      class: {
        'zero-count': _vm.count === 0
      }
    }, [_vm._v("\n        " + _vm._s(_vm.count) + "\n      ")]) : _vm._e()];
  }), _vm._v(" "), _vm._t("default")], 2)]);

}
var staticRenderFns = []

export { render, staticRenderFns }